/**
 * Canonical public URLs for Fitxess legal pages.
 *
 * These point to the public website hosted on Cloudflare Pages at
 * legal.fitxess.com. They are used for every external-facing link in the app
 * (Login footer, Paywall footer, Settings/Legal "Read Full" buttons).
 *
 * The in-app React routes /privacy and /terms still exist and render the same
 * copy from src/content/legal.js — useful for direct navigation and as an
 * offline/fallback path — but all user-surface links use the public URLs so
 * they match what App Store reviewers, email footers, and marketing pages
 * reference.
 */
export const PRIVACY_URL = 'https://legal.fitxess.com/privacy';
export const TERMS_URL = 'https://legal.fitxess.com/terms';
